import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CrosswordList } from '../../components/Crossword/CrosswordList';
import { ListControls } from '../../components/UI/ListControls';
import { clearError, setActiveFilter } from '../../redux/reducers/crosswords';
import { getCrosswords } from '../../redux/actions/crosswords';
import { getFilteredCrosswords } from '../../redux/selectors/crosswords';
import { utils } from '../../utils/helpers';
const ListCrosswordsComponent = ({ crosswords, activeFilter, getCrosswords, clearError, setActiveFilter, }) => {
    const [layout, setLayout] = useState(utils.getLocalStorage('crossword-list-layout', 'List'));
    const [page, setPage] = useState({
        current: 1,
        size: utils.getLocalStorage('quiz-list-page-size', 5),
    });
    const [visibleCrosswords, setVisibleCrosswords] = useState([]);
    useEffect(() => {
        if (crosswords.length <= 1)
            getCrosswords({});
        return () => {
            clearError();
        };
    }, []);
    useEffect(() => {
        const startIndex = (page.current - 1) * page.size;
        const endIndex = startIndex + page.size;
        const paginatedQCrosswords = crosswords.slice(startIndex, endIndex);
        setVisibleCrosswords(paginatedQCrosswords);
    }, [crosswords, page]);
    const updateLayout = (layout) => {
        const newPageSize = layout === 'Grid'
            ? crosswords.length
            : utils.getLocalStorage('rossword-list-page-size', 5);
        setPage({ current: 1, size: newPageSize });
        setLayout(layout);
        utils.setLocalStorage('rossword-list-layout', layout);
    };
    const updateFilter = ({ status, text, }) => {
        setActiveFilter({ status, text });
        setPage({ ...page, current: 1 });
    };
    const updatePage = ({ current, size }) => {
        setPage({ current, size });
        // Save page size to localStorage (but not for Grid layout which shows all items)
        if (layout !== 'Grid') {
            utils.setLocalStorage('crossword-list-page-size', size);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListControls, { totalLength: crosswords.length, layout: layout, updateLayout: updateLayout, activeFilter: activeFilter, updateFilter: updateFilter, page: page, updatePage: updatePage }),
        React.createElement(CrosswordList, { crosswords: visibleCrosswords, layout: layout })));
};
/**
 * Maps Redux state to component props
 */
const mapStateToProps = (state) => ({
    crosswords: getFilteredCrosswords(state.crosswordState.crosswords, state.crosswordState.activeFilter),
    activeFilter: state.crosswordState.activeFilter,
    loading: state.crosswordState.loading,
    error: state.crosswordState.error,
    errorDetail: state.crosswordState.errorDetail,
});
/**
 * Redux action creators to be bound to component props
 */
const mapDispatchToProps = {
    getCrosswords,
    clearError,
    setActiveFilter,
};
export const ListCrosswords = connect(mapStateToProps, mapDispatchToProps)(ListCrosswordsComponent);
